module.exports = __webpack_public_path__ + "fonts/TelefonicaWeb-Thin.ca9333d1.woff";